import SearchIcon from '@mui/icons-material/Search';
import Paper from '@mui/material/Paper';
import Access, { ACTIONS, MODULES, ProtectedRoute } from 'components/Access';
import Button from 'components/Button/Button';
import Layout from 'components/PageWrapper';
import Tabs from 'components/Tabs/Tabs';
import WithFeature from 'components/WithFeature';
import TextField from 'components/form/TextInput';
import FEATURES from 'constants/features';
import React, { createContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Route, Switch } from 'react-router-dom';
import AllVideos from './containers/AllVideos';
import CreateVideo from './containers/CreateVideo';
import DeletedVideos from './containers/DeletedVideos';
import FavoriteVideos from './containers/FavoriteVideos';
import Templates from './containers/Templates';

export const VideosContext = createContext({
  query: '',
});

const VideoRoutes = ({ location }) => {
  const [t] = useTranslation();
  const [query, setQuery] = useState('');

  const filterVideos = (videos) => {
    if (!query) return videos;
    if (!videos) return;
    const ql = query.toLowerCase();
    return videos.filter(
      ({ message, headline }) =>
        headline.toLowerCase().includes(ql) ||
        message.toLowerCase().includes(ql),
    );
  };

  return (
    <WithFeature
      feature={FEATURES.VIDEO}
      message={t(
        'common:no-feature-access',
        'You do not have access to this feature.',
      )}
    >
      <Switch>
        <ProtectedRoute
          action={ACTIONS.MODIFY}
          module={MODULES.VIDEO_NOTES}
          path="/pages/create"
          component={CreateVideo}
        />
        <ProtectedRoute
          action={ACTIONS.MODIFY}
          module={MODULES.VIDEO_NOTES}
          path="/pages/edit/:id"
          component={CreateVideo}
        />
        <Layout
          title="Pages"
          breadcrumbs={[{ title: 'Pages' }]}
          actions={
            <>
              <TextField
                margin="none"
                placeholder="Search..."
                startAdornment={<SearchIcon />}
                sx={{
                  mr: 2,
                  width: 300,
                }}
                size="small"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              <Access module={MODULES.VIDEO_NOTES} action={ACTIONS.MODIFY}>
                <Button component={Link} to="/pages/create">
                  Add New
                </Button>
              </Access>
            </>
          }
        >
          <Paper variant="outlined">
            <Tabs
              tabs={[
                {
                  label: 'All',
                  value: '/pages',
                  to: '/pages',
                  component: Link,
                },
                {
                  label: 'Favorite',
                  value: '/pages/favorite',
                  to: '/pages/favorite',
                  component: Link,
                },
                {
                  label: 'Deleted',
                  value: '/pages/deleted',
                  to: '/pages/deleted',
                  component: Link,
                },
              ]}
              value={location.pathname}
            >
              <VideosContext.Provider
                value={{
                  query,
                  filterVideos,
                }}
              >
                <Switch>
                  <Route path="/pages/favorite" component={FavoriteVideos} />
                  <Route path="/pages/templates" component={Templates} />
                  <Route path="/pages/deleted" component={DeletedVideos} />
                  <Route exact path="/pages" component={AllVideos} />
                </Switch>
              </VideosContext.Provider>
            </Tabs>
          </Paper>
        </Layout>
      </Switch>
    </WithFeature>
  );
};

export default VideoRoutes;
